exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\r\n  width: 300px;\r\n  /* height: 370px; */\r\n  position: relative;\r\n}\r\n\r\n.main-heading {\r\n  font-size: 20px;\r\n  color: rgb(190, 39, 39) !important;\r\n}\r\n\r\n.ratings i {\r\n  color: orange;\r\n}\r\n\r\n.user-ratings h6 {\r\n  margin-top: 2px;\r\n}\r\n\r\n.colors {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-top: 2px;\r\n}\r\n\r\n.colors span {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-right: 6px;\r\n}\r\n\r\n.btn-danger {\r\n  /* height: 48px; */\r\n  /* font-size: 18px; */\r\n  /* position: absolute; */\r\n  /* bottom: 1px; */\r\n  /* right: 2px; */\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/market-place/market-place.component.css
// module id = ../../../../../src/app/parent/dashboard/pages/market-place/market-place.component.css
// module chunks = main